import React, { useEffect, useState } from 'react';
import { MovieHero } from './MovieHero';
import { MovieRow } from './MovieRow';
import { WelcomeModal } from './WelcomeModal';
import { MoviePlayer } from './MoviePlayer';
import { SearchBar } from './SearchBar';
import { PlayIcon } from '@heroicons/react/24/outline';
const ALL_MOVIES = [{
  id: '1',
  title: 'Inception',
  thumbnail: 'https://images.unsplash.com/photo-1440404653325-ab127d49abc1',
  duration: '2h 28m',
  genre: 'Sci-Fi',
  year: '2010',
  rating: 'PG-13'
}, {
  id: '2',
  title: 'Interstellar',
  thumbnail: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa',
  duration: '2h 49m',
  genre: 'Sci-Fi',
  year: '2014',
  rating: 'PG-13'
}, {
  id: '3',
  title: 'Dune',
  thumbnail: 'https://images.unsplash.com/photo-1547499417-61a435d27cb3',
  duration: '2h 35m',
  genre: 'Sci-Fi',
  year: '2021',
  rating: 'PG-13'
}, {
  id: '4',
  title: 'The Matrix',
  thumbnail: 'https://images.unsplash.com/photo-1504981983529-9ed8031ade7f',
  duration: '2h 16m',
  genre: 'Action',
  year: '1999',
  rating: 'R'
}];
const CONTINUE_WATCHING = [{
  id: '5',
  title: 'Blade Runner 2049',
  thumbnail: 'https://images.unsplash.com/photo-1534972195531-d756b9bfa9f2',
  duration: '1h 12m left',
  genre: 'Sci-Fi',
  year: '2017',
  rating: 'R',
  progress: 65
}, {
  id: '6',
  title: 'Ex Machina',
  thumbnail: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e',
  duration: '45m left',
  genre: 'Sci-Fi',
  year: '2014',
  rating: 'R',
  progress: 75
}];
export const MoviesContent = () => {
  const [showWelcome, setShowWelcome] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredMovies, setFilteredMovies] = useState(ALL_MOVIES);
  const [isMobile, setIsMobile] = useState(false);
  // Check if the viewport is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem('hasSeenMoviesWelcome');
    if (!hasSeenWelcome) {
      setShowWelcome(true);
    }
  }, []);
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const filtered = ALL_MOVIES.filter(movie => movie.title.toLowerCase().includes(query.toLowerCase()));
    setFilteredMovies(filtered);
  };
  const handleCloseWelcome = () => {
    localStorage.setItem('hasSeenMoviesWelcome', 'true');
    setShowWelcome(false);
  };
  return <div className="bg-[#141414] min-h-screen w-full" style={{
    backgroundImage: "url('https://images.unsplash.com/photo-1574267432553-4b4628081c31?auto=format&fit=crop&w=2000&q=80')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }} data-id="element-424">
      <div className="absolute inset-0 bg-gradient-to-b from-[#141414] via-transparent to-[#141414] pointer-events-none" data-id="element-425" />
      <WelcomeModal isOpen={showWelcome} onClose={handleCloseWelcome} data-id="element-426" />
      {isPlaying ? <MoviePlayer onClose={() => setIsPlaying(false)} data-id="element-427" /> : <div className="relative" data-id="element-428">
          {/* Different hero for mobile and desktop */}
          {isMobile ? <div className="bg-black min-h-screen w-full pb-20" data-id="element-429">
              <div className="min-h-screen w-full" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1574267432553-4b4628081c31?auto=format&fit=crop&w=2000&q=80')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }} data-id="element-430">
                <div className="absolute inset-0 bg-gradient-to-b from-[#141414] via-transparent to-[#141414] pointer-events-none" data-id="element-431" />
                <WelcomeModal isOpen={showWelcome} onClose={handleCloseWelcome} data-id="element-432" />
                {isPlaying ? <MoviePlayer onClose={() => setIsPlaying(false)} data-id="element-433" /> : <div className="relative" data-id="element-434">
                    <div className="pt-4 px-4" data-id="element-435">
                      <h1 className="text-2xl font-bold mb-4" data-id="element-436">
                        Movies on Spotify
                      </h1>
                      <div className="mb-6 w-full" data-id="element-437">
                        <SearchBar onSearch={handleSearch} placeholder="Search movies..." recentSearches={[]} onClearRecentSearches={() => {}} onRemoveRecentSearch={() => {}} data-id="element-438" />
                      </div>
                      {/* Featured movie card for mobile */}
                      <div className="relative aspect-[16/9] rounded-lg overflow-hidden mb-6" onClick={() => setIsPlaying(true)} data-id="element-439">
                        <img src="https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=450&fit=crop" alt="The Batman" className="w-full h-full object-cover" onError={e => {
                  e.currentTarget.src = 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=450&fit=crop';
                }} data-id="element-440" />
                        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" data-id="element-441" />
                        <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-442">
                          <div className="flex items-center space-x-2 mb-1" data-id="element-443">
                            <span className="text-green-500 font-bold text-sm" data-id="element-444">
                              98% Match
                            </span>
                            <span className="border text-xs px-1" data-id="element-445">PG-13</span>
                          </div>
                          <h2 className="text-xl font-bold" data-id="element-446">The Batman</h2>
                          <button className="mt-2 bg-white text-black rounded-full px-4 py-1 text-sm font-medium flex items-center" data-id="element-447">
                            <PlayIcon className="w-4 h-4 mr-1" data-id="element-448" />
                            Play
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative z-20 pb-20 px-4" data-id="element-449">
                      <MovieRow title="Continue Watching" movies={CONTINUE_WATCHING} onPlayMovie={() => setIsPlaying(true)} isMobile={isMobile} data-id="element-450" />
                      <MovieRow title={searchQuery ? 'Search Results' : 'Trending Now'} movies={searchQuery ? filteredMovies : ALL_MOVIES} onPlayMovie={() => setIsPlaying(true)} isMobile={isMobile} data-id="element-451" />
                      {!searchQuery && <MovieRow title="New Releases" movies={ALL_MOVIES.slice().reverse()} onPlayMovie={() => setIsPlaying(true)} isMobile={isMobile} data-id="element-452" />}
                    </div>
                  </div>}
              </div>
            </div> : <MovieHero onPlay={() => setIsPlaying(true)} data-id="element-453" />}
        </div>}
    </div>;
};